import React, { useState, useEffect } from "react";
import "../Testimonial/Testimonial.css";

const testimonialsData = [
  {
    id: 1,
    image: "t1.avif",
    text: "I am amazed at the quality of plants from this nursery. The saplings are healthy, and they even provide detailed care instructions. My garden has never looked so beautiful!",
    name: "Arjun Kumar",
    post: "Plant Enthusiast",
  },
  {
    id: 2,
    image: "t2.webp",
    text: "This nursery has a fantastic collection of indoor and outdoor plants. Their staff is very knowledgeable and guided me in selecting the perfect plants for my balcony.",
    name: "Priya Sharma",
    post: "Home Gardener",
  },
  {
    id: 3,
    image: "t3.webp",
    text: "I found rare flowering plants here that I couldn’t find anywhere else. The quality is exceptional, and their packaging ensures safe delivery to your doorstep.",
    name: "Ravi Patel",
    post: "Horticulture Student",
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatically change testimonial every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonialsData.length - 1 ? 0 : prevIndex + 1,
      );
    }, 3000);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="testimonials">
      {/* Left Side: Image */}
      <div className="testimonials-left">
        <div className="image-container">
          <img
            src={testimonialsData[currentIndex].image}
            alt="testimonial"
            className="testimonial-image"
          />
        </div>
        <div className="navigation-dots">
          {testimonialsData.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* Right Side: Text and Details */}
      <div className="testimonials-right">
        <h2>Testimonial</h2>
        <p>Hear what our happy plant lovers have to say!</p>
        <div className="testimonial-text">
          <p>"{testimonialsData[currentIndex].text}"</p>
        </div>
        <div className="testimonial-details">
          <h4>{testimonialsData[currentIndex].name}</h4>
          <span>{testimonialsData[currentIndex].post}</span>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
